var React = require('react');

function Lc (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd"},[React.createElement("path",{"fill":"#65cfff","d":"M0 0h640v480H0z","key":0}),React.createElement("path",{"fill":"#fff","d":"M318.9 42l162.7 395.3-322.6.9L318.9 42z","key":1}),React.createElement("path",{"d":"M319 96.5l140.8 340-279 .8L319 96.5z","key":2}),React.createElement("path",{"fill":"#ffce00","d":"M318.9 240.1l162.7 197.6-322.6.5 159.9-198.1z","key":3})]));
}

Lc.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Lc;

Lc.default = Lc;
